import { Box, Stack } from "@mui/material";
import { EfficiencyMetricsCards } from "./EfficiencyMetricsCards";

interface TargetVsActualItem {
  Proportional_Target: number;
  Actual: number;
  Target: number;
  Comment: string;
  Metrics: string;
  RR: number;
  Proportional_Attainment: number;
}

interface EfficiencyMetricsProps {
  data: TargetVsActualItem[];
}

function fmt(value: number): string {
  const rounded = Math.round(value);
  return `$${rounded.toLocaleString()}`;
}

// CAC / CPC are negative metrics (lower is better)
// Red → > 100%, Yellow → 90-100%, Green → below 90%
function getNegativeRrColor(
  attainment: number,
): "success" | "warning" | "error" {
  if (attainment < 0.9) return "success"; // Green → below 90%
  if (attainment <= 1.0) return "warning"; // Yellow → 90% to 100%
  return "error"; // Red → > 100%
}

export default function EfficiencyMetrics({ data }: EfficiencyMetricsProps) {
  const findMetric = (name: string) =>
    data?.find((item) => item.Metrics?.toLowerCase() === name.toLowerCase());

  const cpc = findMetric("cpc");
  const cac = findMetric("CAC");

  return (
    <Box>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2}>
          {cpc && (
            <EfficiencyMetricsCards
              title="CPC"
              value={fmt(cpc.Actual)}
              total={fmt(cpc.Target)}
              rr={`${(cpc.Proportional_Attainment * 100).toFixed(1)}%`}
              pr={fmt(cpc.RR)}
              rrColor={getNegativeRrColor(cpc.Proportional_Attainment)}
            />
          )}

          {cac && (
            <EfficiencyMetricsCards
              title="CAC"
              value={fmt(cac.Actual)}
              total={fmt(cac.Target)}
              rr={`${(cac.Proportional_Attainment * 100).toFixed(1)}%`}
              pr={fmt(cac.RR)}
              rrColor={getNegativeRrColor(cac.Proportional_Attainment)}
            />
          )}
        </Stack>
      </Stack>
    </Box>
  );
}
